<div id="form" class="login-body">
    <div class="login-panel ui-fluid Custompanel">
        <div class="BioPharmaLogo" >
            <!--<a [routerLink]="['/login']" class="login-logo">-->
            <img src="{{baseUrl}}/assets/content/logo/{{applicationLogo}}"/>
            <!--</a>-->
        </div>

        <div>
        <!-- /.login-logo -->
        <div class="login-panel-content">
            <h1 class="login-box-msg paraHeader">Register</h1>
 
            <form  [formGroup]="registerForm" (ngSubmit)="registrationSubmit()" > 
                <div style="position: relative;">               
                <div class="emptyRow">User Name</div>
                <div class="form-group has-feedback">
                    <input type="text"  id ="UserName" [setelementautofocus] formControlName="UserName" class="form-control" [(ngModel)]="userregistration.UserName"   required   autocomplete="off" 
                    style="width:90%;padding-left: 32px;" />
                    <span class="glyphicon glyphicon-user form-control-feedback CustomIcon"></span>
                      
                </div>
                <div class="form-group">
                 <!--   <div *ngIf="registerForm.submitted && !username.valid" class="has-error"> -->
                        <div *ngIf="formErrors.UserName"class="has-error">{{ formErrors.UserName }}</div>   
                   <!-- </div>-->
                </div> 
                <div class="popover__wrapper">                  

                        <div class="popover__title">
                           <span class="glyphicon glyphicon-info-sign"></span>
                            <!-- Info -->
                        </div>
                  
                    <div class="popover__content"  style="width:275px !important;">
                        <p class="popover__message">

                            <ul class="list-unstyled">
                                <li><span class="fa fa-caret-right">&nbsp;</span>User Name should be your Email-Id</li>
                                
                            </ul>

                    </div>
                </div>
            </div>
                
                <div style="position: relative;">
                <div class="emptyRow">New Password</div>
                <div class="form-group has-feedback">
                    <input type="password" forbiddenName ="userregistration.UserName" id="password" formControlName="password" [(ngModel)]="userregistration.password" class="form-control"  required 
                    style="width:90%;padding-left: 32px;"/>                      
                    <span class="glyphicon glyphicon-lock form-control-feedback"></span>                   
                </div>

                
                <div class="form-group">
                    <div *ngIf="formErrors.password" class="has-error"> <p style="white-space: pre-wrap;margin-bottom: -15px;">{{ formErrors.password }}</p></div>
                </div>
                <div class="popover__wrapper">
                  

                        <div class="popover__title">
                         <span class="glyphicon glyphicon-info-sign"></span>
                            <!-- Info -->
                        </div>
                   
                    <div class="popover__content">
                        <p class="popover__message">

                            <ul class="list-unstyled">
                                <li><span class="fa fa-caret-right">&nbsp;</span>Password must
                                    contain
                                    characters from at least three of the following four categories:
                                    Z)</li>
                                <li><span class="fa fa-caret-right">&nbsp;</span>English uppercase characters (A
                                    through
                                    Z)</li>
                                <li><span class="fa fa-caret-right">&nbsp;</span>English lowercase characters (a
                                    through
                                    z)</li>
                                <li><span class="fa fa-caret-right">&nbsp;</span>Base 10 digits (0 through 9)
                                </li>
                                <li><span class="fa fa-caret-right ">&nbsp;</span>Non-alphabetic characters
                                    (e.g.: !,
                                    $, #,
                                    %)</li>

                                <li><span class="fa fa-caret-right ">&nbsp;</span>Passwords must
                                    not
                                    contain a string of three or more identical or consecutive characters
                                    (ex:
                                    123,
                                    AAA)</li>
                            </ul>

                    </div>
                </div>
            </div>



                <div class="emptyRow">Confirm Password</div>
                <div class="form-group has-feedback">
                    <input type="password" id="confirmPassword" class="form-control" formControlName="confirmPassword" [(ngModel)]="userregistration.confirmPassword" required 
                    style="width:90%;padding-left: 32px;"/>
                    <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                </div>
                <div class="form-group">
                    <div *ngIf="formErrors.confirmPassword" class="has-error"> <p style="white-space: pre-wrap; margin-bottom: -10px;">{{ formErrors.confirmPassword }}</p></div>
                </div>
                <div class="row">
                    <!-- /.col -->
                    <div class="col-xs-8">
                        <button type="submit" [disabled]="!registerForm.valid || !enableregister" class="btn RegisterBtn" title="register" name="register"><i class="fa fa-sign-in fa-1"></i>&nbsp;Register</button>&nbsp;
                    </div>
                    <!-- /.col -->
                </div>
            </form>

        </div>
    </div>
        <!-- /.login-box-body -->
    </div>


  <p-dialog header="Password Mismatch!" resizable="false" [closable]="false" 
        closeOnEscape="false" [(visible)]="display" modal="true" [draggable]=false>
    The New Password and Confirm Password entries does not match. Please try again
    <footer>
        <div class="emptyRow">
        <span id="btn-login"><button type="button" class="btn btn-warning pull-right" (click)="display = false">OK</button></span>
    </div>
    </footer>
  </p-dialog>

    <!-- /.login-box -->
</div>

     
<p-dialog header= {{warningHeader}} resizable="false" [closable]="false" 
          closeOnEscape="false" [(visible)]="displayInvalidLink" modal="true" [draggable]=false>
    {{warningMessage}}
    <footer>
        <div class="emptyRow">
            <span id="btn-login"><button type="button" class="btn btn-warning pull-right" (click)="redirectToLogin()">OK</button></span>
        </div>
    </footer>
</p-dialog>

<div class="img-responsive">
    <div class="cssload-spin-box"></div>
</div>
<div class="blockUIDialog" *ngIf="loading" role="dialog">
    <div class="splash-screen">
        <div class="splash-loader-container">
            <p-progressSpinner strokeWidth="3"></p-progressSpinner>
        </div>
    </div>
</div>